<template>
  <div class="chart-bar">
    <div class="chart-card">
      <div class="card-item-inner l2-1">
        <div class="card-title">
          <div>执常委情况</div>
        </div>
        <div  v-if="executiveOmmitteeBaseInfo.position != '主席' &&
         executiveOmmitteeBaseInfo.position != '副主席' && executiveOmmitteeBaseInfo.position != '会长' &&
         executiveOmmitteeBaseInfo.position != '副会长'"
              class="card-content">
          <div class="group_10 flex-col">
            <div class="box_12 flex-row">
              <div class="block_6 flex-col">
                <div class="image-wrapper_1 flex-col">
                  <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="~img/member/center-top-sub-title-icon-1.png"
                  />
                </div>
                <span class="text_94">基础信息</span>
              </div>
              <div class="block_7 flex-row">
<!--                <span class="text_95">执常委</span>-->
<!--                <img-->
<!--                    class="thumbnail_5"-->
<!--                    referrerpolicy="no-referrer"-->
<!--                    src="https://lanhu-oss-2537-2.lanhuapp.com/3185f6e1e81cd4cf243c98b6ad10ec8b"-->
<!--                />-->
                <div class="filter-box">
                  <ElementSelect
                      :val="topSelectType"
                      :options="topSelectTypeList"
                      @change="
                        (e) => {
                          topSelectType = e;
                        }
                      "
                      class="ml12 long-select"
                  />
                  <ElementSelect
                      :val="executiveOmmitteeBaseInfoSelectPersonName"
                      :options="executiveOmmitteeBaseInfoPersonName"
                      @change="
                        (e) => {
                          executiveOmmitteeBaseInfoSelectPersonName = e;
                          executiveOmmitteeBaseInfoSelectEnterpriseName = ''
                          getExecutiveOmmitteeBaseInfo()
                        }
                      "
                      class="ml12 long-select"
                      v-if="topSelectType === 0"
                      filterable
                  />
                  <ElementSelect
                      :val="executiveOmmitteeBaseInfoSelectEnterpriseName"
                      :options="executiveOmmitteeBaseInfoEnterpriseName"
                      @change="
                        (e) => {
                          executiveOmmitteeBaseInfoSelectEnterpriseName = e;
                          executiveOmmitteeBaseInfoSelectPersonName = ''
                          getExecutiveOmmitteeBaseInfo()
                        }
                      "
                      class="ml12 long-select"
                      v-if="topSelectType === 1"
                      filterable
                  />
                </div>
              </div>
              <div class="block_8 flex-col justify-between">
<!--                <div class="group_11 flex-row justify-between">-->
<!--                  <img-->
<!--                      class="thumbnail_6"-->
<!--                      referrerpolicy="no-referrer"-->
<!--                      :src="`${baseUrl}${executiveOmmitteeBaseInfo.image_url}`"-->
<!--                  />-->
<!--                  <span class="text_96">请输入执常委姓名</span>-->
<!--                </div>-->
<!--                <div class="group_12 flex-col"></div>-->
              </div>
              <div class="block_9 flex-col justify-between">
                <div class="block_10 flex-row">
                  <div class="block_10_image-wrapper_1 flex-col">
                    <img
                        class="thumbnail_4"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-top-sub-title-icon-2.png"
                    />
                  </div>
                  <span class="text_97">参政议政</span>
                </div>
              </div>
            </div>
            <div class="box_13 flex-row">
              <div class="group_13 flex-col">
                <div class="block_11 flex-col">
                  <div class="group_14 flex-row">
                    <div class="box_14 flex-col">
<!--                      <img-->
<!--                          :src="`${baseUrl}${executiveOmmitteeBaseInfo.image_url}`"-->
<!--                      />-->
<!--                      <img-->
<!--                          :src="executiveOmmitteeBaseInfo.image_url ? baseUrl +-->
<!--                          executiveOmmitteeBaseInfo.image_url : '~img/member/default-avatar.png'"-->
<!--                      />-->
                      <img
                          :src="`${executiveOmmitteeBaseInfo.image_url ? baseUrl +
                          executiveOmmitteeBaseInfo.image_url :
                          require('../../../assets/member/default-avatar.png')}`"
                      />
                    </div>
                    <div class="text-wrapper_18 flex-col justify-between">
                      <span class="text_98">姓名:</span>
                      <span class="text_99">性别:</span>
                    </div>
                    <div class="text-wrapper_19 flex-col">
                      <span class="text_100" @click="executiveOmmitteeBaseInfoClick">
                        详情&gt;
                      </span>
                      <span class="text_101">{{ executiveOmmitteeBaseInfo.person_name || '-' }}</span>
                      <span class="text_102">{{ executiveOmmitteeBaseInfo.sex || '-' }}</span>
                    </div>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_103">年龄:</span>
                    <span class="text_104">{{ executiveOmmitteeBaseInfo.age || '-' }}岁</span>
                    <span class="text_105">学历:</span>
                    <span class="text_106">{{ executiveOmmitteeBaseInfo.educational_background || '-' }}</span>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_107">民族:</span>
                    <span class="text_108">{{ executiveOmmitteeBaseInfo.nationality || '-' }}</span>
                    <span class="text_109">工商联职务:</span>
                    <span class="text_110">{{ executiveOmmitteeBaseInfo.position || '-' }}</span>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_107_1">政治面貌:</span>
                    <span class="text_108">{{ executiveOmmitteeBaseInfo.political_appearance || '-' }}</span>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_107_2">所在工商联:</span>
                    <span class="text_108">{{ executiveOmmitteeBaseInfo.belong_org || '-' }}</span>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_107_2">执常委类型:</span>
                    <span class="text_108">{{ executiveOmmitteeBaseInfo.executive_committee_person_type || '-' }}</span>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_107_2">执常委状态:</span>
                    <span class="text_108">{{ executiveOmmitteeBaseInfo.executive_standing_committee_status || '-' }}</span>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_107_2">单位及职务:</span>
                    <span class="text_108_1">{{ executiveOmmitteeBaseInfo.unit_and_position || '-' }}</span>
                  </div>
                </div>
                <!--<div class="image-wrapper_2 flex-col">-->
                  <!--<img-->
                      <!--class="image_10"-->
                      <!--referrerpolicy="no-referrer"-->
                      <!--src="~img/member/center-top-sub-title-icon-3.png"-->
                  <!--/>-->
                <!--</div>-->
                <!--<div class="block_12 flex-col">-->
                  <!--<span class="text_111" @click="associatedCompanyInfoClick">详情&gt;</span>-->
                  <!--<span class="text_112">企业名称</span>-->
                  <!--<span class="text_113">{{ executiveOmmitteeBaseInfo.enterprise_registered_name || '-' }}</span>-->
                  <!--<span class="text_114">法人代表</span>-->
                  <!--<span class="text_115">{{ executiveOmmitteeBaseInfo.legal_representative_person || '-' }}</span>-->
                  <!--<span class="text_116">行业代码</span>-->
                  <!--<span class="text_117">{{ executiveOmmitteeBaseInfo.enterprise_industry_classification || '-' }}</span>-->
                  <!--<div class="text-group_1 flex-col justify-between">-->
                    <!--<span class="text_118">企业健康监测</span>-->
                    <!--<span class="text_119" v-if="executiveOmmitteeBaseInfo.health === '健康'">-->
                      <!--{{ executiveOmmitteeBaseInfo.health || '-' }}</span>-->
                    <!--<span class="text_119-1" v-else>-->
                      <!--{{ executiveOmmitteeBaseInfo.health || '-' }}-->
                      <!--<span class="text_119_1_1" @click="warnInfoClick">查看预警&gt;</span>-->
                    <!--</span>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<span class="text_120">关联企业</span>-->
              </div>
              <div class="group_15 flex-col">
                <div class="box_15 flex-col">
                  <span class="text_121" :title="getFullPerformanceOfDuties(2)">{{ performanceOfDutiesTwo }}</span>
                  <div class="image-wrapper_3 flex-col">
                    <img
                        class="image_11"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-tab-line.png"
                    />
                  </div>
                </div>
                <div class="box_16 flex-col">
                  <div class="text-wrapper_22 flex-col">
                    <span class="text_122" :title="getFullPerformanceOfDuties(6)">{{ performanceOfDutiesSix }}</span>
<!--                    <span class="text_123">开展乡村产业振兴</span>-->
                  </div>
                  <div class="text-wrapper_23 flex-col">
                    <span class="text_124" :title="getFullPerformanceOfDuties(4)">{{ performanceOfDutiesFour }}</span>
                  </div>
                  <div class="image-wrapper_4 flex-col">
                    <img
                        class="image_12"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-tab-line.png"
                    />
                  </div>
                  <div class="image-wrapper_5 flex-col">
                    <img
                        class="image_13"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-tab-line.png"
                    />
                  </div>
                </div>
                <div class="image-wrapper_6 flex-row justify-between">
                  <img
                      class="image_14"
                      referrerpolicy="no-referrer"
                      src="~img/member/center-sub-title-bg.png"
                  />
                  <img
                      class="image_15"
                      referrerpolicy="no-referrer"
                      src="~img/member/center-sub-title-bg.png"
                  />
                </div>
                <div class="box_17 flex-row justify-between">
                  <div class="box_18 flex-col">
                    <div class="box_18_1 flex-col">
                      <div
                          :class="{'box_19': index % 2 === 1, 'box_21': index % 2 === 0}"
                           v-for="(item, index) in
                           executiveCommitteePerformance.social_position_list">
                        <div class="box_20 flex-row justify-between">
                          <div class="section_9 flex-col"></div>
                          <div class="section_10 flex-col"></div>
                          <div class="section_11 flex-col"></div>
                        </div>
                        <div class="text-wrapper_24 flex-row">
                          <span class="text_125">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_24 flex-col">
                    <div class="box_18_1 flex-col">
                      <div
                          :class="{'box_19': index % 2 === 1, 'box_21': index % 2 === 0}"
                          v-for="(item, index) in
                           executiveCommitteePerformance.corporate_honors_list">
                        <div class="box_20 flex-row justify-between">
                          <div class="section_9 flex-col"></div>
                          <div class="section_10 flex-col"></div>
                          <div class="section_11 flex-col"></div>
                        </div>
                        <div class="text-wrapper_24 flex-row">
                          <span class="text_125">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box_36 flex-row">
                  <img
                      class="label_5"
                      referrerpolicy="no-referrer"
                      src="~img/member/center-top-sub-title-icon-4.png"
                  />
                  <span class="text_132">社会职务</span>
                  <img
                      class="label_6"
                      referrerpolicy="no-referrer"
                      src="~img/member/center-top-sub-title-icon-5.png"
                  />
                  <span class="text_133">企业荣誉</span>
                </div>
              </div>
              <div class="group_25 flex-col">
                <div class="group_25_div flex-col">
                  <div class="box_37 flex-col"
                       v-for="(item, index) in
                           executiveCommitteePerformance.participate_political_offer_list">
                    <img
                        class="image_16"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-right-line.png"
                    />
                    <span class="text_134">{{ item }}</span>
                    <img
                        class="image_17"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-right-line.png"
                    />
                  </div>
                </div>




              </div>

              <div class="group_25_1 flex-col">
              <div class="image-wrapper_2 flex-col">
                <img
                        class="image_10"
                        referrerpolicy="no-referrer"
                        src="~img/member/center-top-sub-title-icon-3.png"
                />
              </div>
              <div class="block_12 flex-col">
                <span class="text_111" @click="associatedCompanyInfoClick">详情&gt;</span>
                <span class="text_112">企业名称</span>
                <span class="text_113">{{ executiveOmmitteeBaseInfo.enterprise_registered_name || '-' }}</span>
                <span class="text_114">法人代表</span>
                <span class="text_115">{{ executiveOmmitteeBaseInfo.legal_representative_person || '-' }}</span>
                <span class="text_116">行业代码</span>
                <span class="text_117">{{ executiveOmmitteeBaseInfo.enterprise_industry_classification || '-' }}</span>
                <div class="text-group_1 flex-col justify-between">
                  <span class="text_118">企业健康监测</span>
                  <span class="text_119" v-if="executiveOmmitteeBaseInfo.health === '健康'">
              {{ executiveOmmitteeBaseInfo.health || '-' }}</span>
                  <span class="text_119-1" v-else>
              {{ executiveOmmitteeBaseInfo.health || '-' }}
              <span class="text_119_1_1" @click="warnInfoClick">查看预警&gt;</span>
              </span>
                </div>
              </div>
              <span class="text_120_1">关联企业</span>

              </div>
            </div>
            <div class="box_47 flex-col">
              <span class="text_138" :title="getFullPerformanceOfDuties(8)">{{ performanceOfDutiesEight }}</span>
<!--              <span class="text_139">开展乡村产业振兴</span>-->
            </div>
            <div class="box_47_2 flex-col">
              <!--<img src="~img/member/center-middle-icon2.png">-->
            </div>
            <div class="box_47_1 flex-col">
              <span class="text_138" :title="getFullPerformanceOfDuties(9)">{{ performanceOfDutiesNinth }}</span>
              <!--              <span class="text_139">开展乡村产业振兴</span>-->
            </div>
            <div class="text-wrapper_32 flex-col">
              <span class="text_140" :title="getFullPerformanceOfDuties(7)">{{ performanceOfDutiesSeven }}</span>
              <!--                <span class="text_141">开展乡村产业振兴</span>-->
            </div>
            <div class="text-wrapper_32_1 flex-col">
              <span class="text_140" :title="getFullPerformanceOfDuties(10)">{{ performanceOfDutiesTen }}</span>
              <!--                <span class="text_141">开展乡村产业振兴</span>-->
            </div>
            <div class="text-wrapper_33 flex-col">
              <span class="text_142" :title="getFullPerformanceOfDuties(1)">{{ performanceOfDutiesOne }}</span>
<!--              <span class="text_143">走访调研2次</span>-->
            </div>
            <div class="text-wrapper_34 flex-col">
              <span class="text_144" :title="getFullPerformanceOfDuties(3)">{{ performanceOfDutiesThree }}</span>
<!--              <span class="text_145">走访调研2次</span>-->
            </div>
            <div class="text-wrapper_35 flex-col">
              <span class="text_146" :title="getFullPerformanceOfDuties(5)">{{ performanceOfDutiesFive }}</span>
<!--              <span class="text_147">制氧机捐款500万</span>-->
            </div>
          </div>
        </div>

        <div v-else class="card-content">
          <div class="group_10 flex-col">
            <div class="box_12 flex-row">
              <div class="block_6 flex-col">
                <div class="image-wrapper_1 flex-col">
                  <img
                          class="thumbnail_4"
                          referrerpolicy="no-referrer"
                          src="~img/member/center-top-sub-title-icon-1.png"
                  />
                </div>
                <span class="text_94">基础信息</span>
              </div>
              <div class="block_7 flex-row">
                <!--                <span class="text_95">执常委</span>-->
                <!--                <img-->
                <!--                    class="thumbnail_5"-->
                <!--                    referrerpolicy="no-referrer"-->
                <!--                    src="https://lanhu-oss-2537-2.lanhuapp.com/3185f6e1e81cd4cf243c98b6ad10ec8b"-->
                <!--                />-->
                <div class="filter-box">
                  <ElementSelect
                          :val="topSelectType"
                          :options="topSelectTypeList"
                          @change="
                        (e) => {
                          topSelectType = e;
                        }
                      "
                          class="ml12 long-select"
                  />
                  <ElementSelect
                          :val="executiveOmmitteeBaseInfoSelectPersonName"
                          :options="executiveOmmitteeBaseInfoPersonName"
                          @change="
                        (e) => {
                          executiveOmmitteeBaseInfoSelectPersonName = e;
                          executiveOmmitteeBaseInfoSelectEnterpriseName = ''
                          getExecutiveOmmitteeBaseInfo()
                        }
                      "
                          class="ml12 long-select"
                          v-if="topSelectType === 0"
                          filterable
                  />
                  <ElementSelect
                          :val="executiveOmmitteeBaseInfoSelectEnterpriseName"
                          :options="executiveOmmitteeBaseInfoEnterpriseName"
                          @change="
                        (e) => {
                          executiveOmmitteeBaseInfoSelectEnterpriseName = e;
                          executiveOmmitteeBaseInfoSelectPersonName = ''
                          getExecutiveOmmitteeBaseInfo()
                        }
                      "
                          class="ml12 long-select"
                          v-if="topSelectType === 1"
                          filterable
                  />
                </div>
              </div>
              <div class="block_8 flex-col justify-between">
                <!--                <div class="group_11 flex-row justify-between">-->
                <!--                  <img-->
                <!--                      class="thumbnail_6"-->
                <!--                      referrerpolicy="no-referrer"-->
                <!--                      :src="`${baseUrl}${executiveOmmitteeBaseInfo.image_url}`"-->
                <!--                  />-->
                <!--                  <span class="text_96">请输入执常委姓名</span>-->
                <!--                </div>-->
                <!--                <div class="group_12 flex-col"></div>-->
              </div>
              <div class="block_9 flex-col justify-between">
                <div class="block_10 flex-row">
                  <div class="block_10_image-wrapper_1 flex-col">
                    <img
                            class="thumbnail_4"
                            referrerpolicy="no-referrer"
                            src="~img/member/center-top-sub-title-icon-2.png"
                    />
                  </div>
                  <span class="text_97">企业荣誉</span>
                </div>
              </div>
            </div>
            <div class="box_13 flex-row">
              <div class="group_13 flex-col">
                <div class="block_11_1 flex-col">
                  <div class="group_14 flex-row">
                    <div class="box_14 flex-col">
                      <!--                      <img-->
                      <!--                          :src="`${baseUrl}${executiveOmmitteeBaseInfo.image_url}`"-->
                      <!--                      />-->
                      <!--                      <img-->
                      <!--                          :src="executiveOmmitteeBaseInfo.image_url ? baseUrl +-->
                      <!--                          executiveOmmitteeBaseInfo.image_url : '~img/member/default-avatar.png'"-->
                      <!--                      />-->
                      <img
                              :src="`${executiveOmmitteeBaseInfo.image_url ? baseUrl +
                          executiveOmmitteeBaseInfo.image_url :
                          require('../../../assets/member/default-avatar.png')}`"
                      />
                    </div>
                    <div class="text-wrapper_18 flex-col justify-between">
                      <span class="text_98">姓名:</span>
                      <span class="text_99">性别:</span>
                    </div>
                    <div class="text-wrapper_19 flex-col">
                      <span class="text_100" @click="executiveOmmitteeBaseInfoClick">
                        详情&gt;
                      </span>
                      <span class="text_101">{{ executiveOmmitteeBaseInfo.person_name || '-' }}</span>
                      <span class="text_102">{{ executiveOmmitteeBaseInfo.sex || '-' }}</span>
                    </div>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_103">年龄:</span>
                    <span class="text_104">{{ executiveOmmitteeBaseInfo.age || '-' }}岁</span>
                    <span class="text_105">学历:</span>
                    <span class="text_106">{{ executiveOmmitteeBaseInfo.educational_background || '-' }}</span>
                  </div>
                  <div class="text-wrapper_21 flex-row">
                    <span class="text_107">民族:</span>
                    <span class="text_108">{{ executiveOmmitteeBaseInfo.nationality || '-' }}</span>
                    <span class="text_109">工商联职务:</span>
                    <span class="text_110">{{ executiveOmmitteeBaseInfo.position || '-' }}</span>
                  </div>
                </div>
                <div class="image-wrapper_2_1 flex-col">
                  <img
                          class="image_10"
                          referrerpolicy="no-referrer"
                          src="~img/member/center-top-sub-title-icon-3.png"
                  />
                </div>
                <div class="block_12_1 flex-col">
                  <span class="text_111" @click="associatedCompanyInfoClick">详情&gt;</span>
                  <span class="text_112">企业名称</span>
                  <span class="text_113">{{ executiveOmmitteeBaseInfo.enterprise_registered_name || '-' }}</span>
                  <span class="text_114">法人代表</span>
                  <span class="text_115">{{ executiveOmmitteeBaseInfo.legal_representative_person || '-' }}</span>
                  <span class="text_116">行业代码</span>
                  <span class="text_117">{{ executiveOmmitteeBaseInfo.enterprise_industry_classification || '-' }}</span>
                  <div class="text-group_1 flex-col justify-between">
                    <span class="text_118">企业健康监测</span>
                    <span class="text_119" v-if="executiveOmmitteeBaseInfo.health === '健康'">
                      {{ executiveOmmitteeBaseInfo.health || '-' }}</span>
                    <span class="text_119-1" v-else>
                      {{ executiveOmmitteeBaseInfo.health || '-' }}
                      <span class="text_119_1_1" @click="warnInfoClick">查看预警&gt;</span>
                    </span>
                  </div>
                </div>
                <span class="text_120">关联企业</span>
              </div>
              <div class="group_15 flex-col">
                <div class="box_15 flex-col">
                  <span class="text_121" :title="getFullPerformanceOfDuties(2)">{{ performanceOfDutiesTwo }}</span>
                  <div class="image-wrapper_3 flex-col">
                    <img
                            class="image_11"
                            referrerpolicy="no-referrer"
                            src="~img/member/center-tab-line.png"
                    />
                  </div>
                </div>
                <div class="box_16_1 flex-col">
                  <div class="text-wrapper_22 flex-col">
                    <span class="text_122" :title="getFullPerformanceOfDuties(6)">{{ performanceOfDutiesSix }}</span>
                    <!--                    <span class="text_123">开展乡村产业振兴</span>-->
                  </div>
                  <div class="text-wrapper_23 flex-col">
                    <span class="text_124" :title="getFullPerformanceOfDuties(4)">{{ performanceOfDutiesFour }}</span>
                  </div>
                  <div class="image-wrapper_4 flex-col">
                    <img
                            class="image_12"
                            referrerpolicy="no-referrer"
                            src="~img/member/center-tab-line.png"
                    />
                  </div>
                  <div class="image-wrapper_5 flex-col">
                    <img
                            class="image_13"
                            referrerpolicy="no-referrer"
                            src="~img/member/center-tab-line.png"
                    />
                  </div>
                </div>
                <div class="image-wrapper_6_1 flex-row justify-between">
                  <img
                          class="image_14"
                          referrerpolicy="no-referrer"
                          src="~img/member/center-sub-title-bg.png"
                  />
                  <img
                          class="image_15"
                          referrerpolicy="no-referrer"
                          src="~img/member/center-sub-title-bg.png"
                  />
                </div>
                <div class="box_17 flex-row justify-between">
                  <div class="box_18_11 flex-col">
                    <div class="box_18_1 flex-col">
                      <div
                              :class="{'box_19': index % 2 === 1, 'box_21': index % 2 === 0}"
                              v-for="(item, index) in
                           executiveCommitteePerformance.social_position_list">
                        <div class="box_20 flex-row justify-between">
                          <div class="section_9 flex-col"></div>
                          <div class="section_10 flex-col"></div>
                          <div class="section_11 flex-col"></div>
                        </div>
                        <div class="text-wrapper_24 flex-row">
                          <span class="text_125">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_24_1 flex-col">
                    <div class="box_18_1 flex-col">
                      <div
                              :class="{'box_19': index % 2 === 1, 'box_21': index % 2 === 0}"
                              v-for="(item, index) in
                           executiveCommitteePerformance.participate_political_offer_list">
                        <div class="box_20 flex-row justify-between">
                          <div class="section_9 flex-col"></div>
                          <div class="section_10 flex-col"></div>
                          <div class="section_11 flex-col"></div>
                        </div>
                        <div class="text-wrapper_24 flex-row">
                          <span class="text_125">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box_36_1 flex-row">
                  <img
                          class="label_5"
                          referrerpolicy="no-referrer"
                          src="~img/member/center-top-sub-title-icon-4.png"
                  />
                  <span class="text_132">社会职务</span>
                  <img
                          class="label_6"
                          referrerpolicy="no-referrer"
                          src="~img/member/center-top-sub-title-icon-5.png"
                  />
                  <span class="text_133">参政议政</span>
                </div>
              </div>
              <div class="group_25_2 flex-col">
                <div class="group_25_div flex-col">
                  <div class="box_37 flex-col"
                       v-for="(item, index) in
                           executiveCommitteePerformance.corporate_honors_list">
                    <img
                            class="image_16"
                            referrerpolicy="no-referrer"
                            src="~img/member/center-right-line.png"
                    />
                    <span class="text_134">{{ item }}</span>
                    <img
                            class="image_17"
                            referrerpolicy="no-referrer"
                            src="~img/member/center-right-line.png"
                    />
                  </div>
                </div>


              </div>
            </div>
            <div class="box_47 flex-col">
              <span class="text_138" :title="getFullPerformanceOfDuties(8)">{{ performanceOfDutiesEight }}</span>
              <!--              <span class="text_139">开展乡村产业振兴</span>-->
            </div>
            <div class="text-wrapper_32 flex-col">
              <span class="text_140" :title="getFullPerformanceOfDuties(7)">{{ performanceOfDutiesSeven }}</span>
              <!--                <span class="text_141">开展乡村产业振兴</span>-->
            </div>
            <div class="text-wrapper_33 flex-col">
              <span class="text_142" :title="getFullPerformanceOfDuties(1)">{{ performanceOfDutiesOne }}</span>
              <!--              <span class="text_143">走访调研2次</span>-->
            </div>
            <div class="text-wrapper_34 flex-col">
              <span class="text_144" :title="getFullPerformanceOfDuties(3)">{{ performanceOfDutiesThree }}</span>
              <!--              <span class="text_145">走访调研2次</span>-->
            </div>
            <div class="text-wrapper_35 flex-col">
              <span class="text_146" :title="getFullPerformanceOfDuties(5)">{{ performanceOfDutiesFive }}</span>
              <!--              <span class="text_147">制氧机捐款500万</span>-->
            </div>
          </div>
        </div>
      </div>
      <div class="card-item l2-2">
        <div class="card-title">
          <div>工商联执常委企业健康监测</div>
        </div>
        <div class="card-content">
          <div class="box_63 flex-row">
            <img
                class="label_7"
                referrerpolicy="no-referrer"
                src="~img/member/center-bottom-title-icon.png"
            />
            <img
                class="image_60"
                referrerpolicy="no-referrer"
                src="~img/member/center-bottom-sub-title.png"
            />
            <div class="text-wrapper_47">
                <span class="text_210"
                >依托大数据动态监测，建立执常委企业健康预警机制，重点监测企业的“</span
                >
              <span class="text_211">经营异常、行政处罚、失信、吊销</span>
              <span class="paragraph_12"
              >”等风险点，有效保障执常委企业合<br />规稳健发展，已纳入监测的企业有</span
              >
              <span class="text_212">{{ tableDataEntHealthTotal.total_count || '-' }}</span>
              <span class="text_213">家，其中</span>
              <span class="text_214">{{ tableDataEntHealthTotal.warn_company_count || '-' }}</span>
              <span class="text_215"></span>
              <span class="text_216">家企业，产生</span>
              <span class="text_214">{{ entHealthTablePager.total || '-' }}</span>
              <span class="text_216">条风险预警记录：</span>
            </div>
          </div>
          <ComTable
              :tableCol="tableColEntHealth"
              :tableData="tableDataEntHealth"
              :pager="entHealthTablePager"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
              style="height: 70%;width: 95%;padding-left: 15px;padding-top: 3px"
          />
        </div>
      </div>
    </div>
    <EleDialog id="executive_ommittee_base_info" title="执常委详情"
               :visible.sync="executiveOmmitteeBaseInfoShow"
               class="executive-ommittee-base-info">
<!--      <div style="overflow: auto">-->
        <el-row :gutter="20" style="">
          <div class="sub-title">
            <span>基础信息</span>
          </div>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              所在工商联
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.belong_org || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              本人手机号
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.mobile || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              执委届别
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.executive_standing_committee_term || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              港澳身份
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.identity_of_hong_kong_and_macao || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              执常委姓名
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.person_name || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              学历
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.educational_background || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              性别
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.sex || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              学位
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.academic_degree || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              执常委人员类型
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.executive_committee_person_type || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              联系人姓名
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.contact_name || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              出生日期
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.born_date || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              联系人手机
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.contact_mobile || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              民族
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.nationality || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              职称
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.professional_title || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              籍贯
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.native_place || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              邮箱
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.email || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              政治面貌
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.political_appearance || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              执常委身份
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.executive_standing_committee_identity || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              证件类型
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.certificate_type || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              执常委状态
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.executive_standing_committee_status || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              证件号码
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.certificate_number || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              行政级别
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.administrative_level || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              单位及职务
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.unit_and_position || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              通讯地址
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.correspondence_address || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              个人简历
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.personal_resume || '-'}}
            </div>
          </el-col>
          <el-col :span="4">

          </el-col>
          <el-col :span="6" style="padding-left: 10px">

          </el-col>
        </el-row>
        <el-row :gutter="20" style="">
          <div class="sub-title">
            <span>职务信息</span>
          </div>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              工商联职务
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.position || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              商会职务
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.chamber_of_commerce_position || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              人大职务
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.national_peoples_congress_positions || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              其他职务
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.other_position || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              政府职务
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.government_position || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              个人荣誉
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.personal_honor || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              政协职务
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.government_political_position || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="">
          <div class="sub-title">
            <span>所属企业</span>
          </div>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              企业所在国家或地区
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.enterprise_region_country || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              成立时间
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.establishment_date || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              企业工商登记名称
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.enterprise_registered_name || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              是否建立团组织
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.if_establish_youth_league_organization || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              工商登记注册类型
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.business_registration_type || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              是否建立党组织
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.if_establish_party_organization || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              法人代表姓名
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.legal_representative_person || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              是否建立工会组织
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.if_establish_trade_union_organization || '-'}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="item-label text-align-right">
              企业规模
            </div>
          </el-col>
          <el-col :span="10" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.enterprise_scale || '-'}}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item-label text-align-right">
              企业行业分类
            </div>
          </el-col>
          <el-col :span="6" style="padding-left: 10px">
            <div class="item-label">
              {{executiveOmmitteeBaseInfo.enterprise_industry_classification || '-'}}
            </div>
          </el-col>
        </el-row>
<!--      </div>-->
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="associatedCompanyInfoShow" class="company-profile">
      <CompModal v-if="associatedCompanyInfoShow" :curData="curData"></CompModal>
    </EleDialog>
    <EleDialog id="warn_info" title="企业健康检测异常详情"
               :visible.sync="warnInfoShow"
               class="warn-info">
      <!--      <div style="overflow: auto">-->
      <el-row>
        <el-col :span="7">
          <div class="item-label text-align-right">
            执常委姓名
          </div>
        </el-col>
        <el-col :span="17" style="padding-left: 10px">
          <div class="item-label">
            {{warnPersonName || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <div class="item-label text-align-right">
            企业名称
          </div>
        </el-col>
        <el-col :span="17" style="padding-left: 10px">
          <div class="item-label">
            {{warnCompanyName || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <div class="item-label text-align-right">
            社会代码
          </div>
        </el-col>
        <el-col :span="17" style="padding-left: 10px">
          <div class="item-label">
            {{warnSocialCode || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <div class="item-label text-align-right">
            所属行业
          </div>
        </el-col>
        <el-col :span="17" style="padding-left: 10px">
          <div class="item-label">
            {{warnEnterpriseIndustryClassification || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <ComTable
            :tableCol="tableColWarn"
            :tableData="tableDataWarn"
            :isPagination="false"
            style="height: 300px;width: 95%;padding-top: 10px"
        />
      </el-row>
    </EleDialog>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartScienceFunds';
import drawBar2 from '../chartJs/chartLicense';
import drawBar3 from '../chartJs/chartPrivateTaxes';
import FinancialService from './FinancialService.vue';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import TabList from '../../../components/tabList';
import MarketSubjectType from './MarketSubjectType';
import MarketMainIndustry from './MarketMainIndustry.vue';
import ElementSelect from '../../../components/element-select';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';
import { getBaseUrl } from '@/utils/common';
import {Message} from "element-ui";
export default {
  name: 'ChartBar',
  components: { ElementSelect, ComTable, TabList, MarketSubjectType, MarketMainIndustry, CompModal, FinancialService },
  props: {
    yearP: {
      type: Number,
      default: 2024,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    leftPersonSelectPerson: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      curData: null,
      tableDataEntHealthTotal: {},
      tableDataEntHealth: [],
      warnInfoShow: false,
      tableDataWarn: [],
      warnPersonName: null,
      warnCompanyName: null,
      warnSocialCode: null,
      warnEnterpriseIndustryClassification: null,
      entHealthTablePager: {
        currentPage: 1,
        pageSize: 2,
        total: 0,
      },
      executiveOmmitteeBaseInfoPersonName: [],
      executiveOmmitteeBaseInfoSelectPersonName: '',
      executiveOmmitteeBaseInfoEnterpriseName: [],
      executiveOmmitteeBaseInfoSelectEnterpriseName: [],
      executiveOmmitteeBaseInfo: {},
      executiveCommitteePerformance: {},
      baseUrl: getBaseUrl(),
      topSelectTypeList: [
        {
          label: "执常委",
          value: 0
        },
        {
          label: "执常委关联企业",
          value: 1
        }
      ],
      topSelectType: 0,
      executiveOmmitteeBaseInfoShow: false,
      associatedCompanyInfoShow: false,




    };
  },
  created() {
    this.getExecutiveOmmitteeBaseInfo();
    this.getExecutiveOmmitteeBaseInfoEnterpriseName();
    this.getExecutiveOmmitteeBaseInfoPersonName();
    this.getExecutiveOmmitteeCompanyHealth()

  },
  computed: {
    tableColEntHealth() {
      return [
        {
          label: '执常委姓名',
          param: 'personName',
          maxWidth: 45,
        },
        {
          label: '企业名称',
          param: 'companyName',
          maxWidth: 110,
        },
        {
          label: '社会代码',
          param: 'socialCode',
          maxWidth: 115,
          minWidth: 115,
        },
        {
          label: '所属行业',
          param: 'enterpriseIndustryClassification',
          maxWidth: 70,
        },
        {
          label: '预警类型',
          param: 'warnType',
          maxWidth: 50,
        },
        {
          label: '预警内容',
          param: 'warnMsg',
        },
        {
          label: '数据更新时间',
          param: 'updateTime',
          maxWidth: 75,
        },
        {
          label: '操作',
          param: 'buttonText',
          maxWidth: 70,
          fn: (x) => {
            this.updateExecutiveOmmitteeCompanyHealthDisable(
                x.personName, x.companyName, x.socialCode, x.warnType, x.reportNo
            );
          },
        },
      ];
    },
    tableColWarn() {
      return [
        {
          label: '预警类型',
          param: 'warnType',
          maxWidth: 60,
        },
        {
          label: '预警内容',
          param: 'warnMsg',
        },
        {
          label: '数据更新时间',
          param: 'updateTime',
          maxWidth: 80,
        },
        {
          label: '操作',
          param: 'buttonText',
          maxWidth: 60,
          fn: (x) => {
            this.updateExecutiveOmmitteeCompanyHealthDisable(
                x.personName, x.companyName, x.socialCode, x.warnType, x.reportNo
            );
          },
        },
      ];
    },
    performanceOfDutiesOne() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 1) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[0];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesTwo() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 2) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[1];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesThree() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 3) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[2];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesFour() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 4) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[3];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesFive() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 5) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[4];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesSix() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 6) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[5];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesSeven() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 7) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[6];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesEight() {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= 8) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[7];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesNinth() {
      if (this.executiveCommitteePerformance &&
              this.executiveCommitteePerformance.performance_of_duties_list &&
              this.executiveCommitteePerformance.performance_of_duties_list.length >= 9) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[8];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },
    performanceOfDutiesTen() {
      if (this.executiveCommitteePerformance &&
              this.executiveCommitteePerformance.performance_of_duties_list &&
              this.executiveCommitteePerformance.performance_of_duties_list.length >= 10) {
        const text = this.executiveCommitteePerformance.performance_of_duties_list[9];
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
      } else {
        return '-'
      }
    },

  },
  watch: {

  },
  methods: {
    getFullPerformanceOfDuties(index) {
      if (this.executiveCommitteePerformance &&
          this.executiveCommitteePerformance.performance_of_duties_list &&
          this.executiveCommitteePerformance.performance_of_duties_list.length >= index) {
        return this.executiveCommitteePerformance.performance_of_duties_list[index - 1];
      } else {
        return '-'
      }
    },
    updateExecutiveOmmitteeCompanyHealthDisable(personName, companyName, socialCode, warnType, reportNo){
      this.$api.member
          .updateExecutiveOmmitteeCompanyHealthDisable({
            personName: personName,
            companyName: companyName,
            socialCode: socialCode,
            warnType: warnType,
            reportNo: reportNo
          }).then((res) => {
        Message.success('修改成功');
        this.getExecutiveOmmitteeCompanyHealth();
        this.getWarnInfo();
        this.getExecutiveOmmitteeBaseInfo();
      });
    },
    getExecutiveOmmitteeCompanyHealth(){
      this.$api.member
          .getExecutiveOmmitteeCompanyHealth({
            pageCurrent: this.entHealthTablePager.currentPage,
            pageSize: this.entHealthTablePager.pageSize
          }).then((res) => {
        this.tableDataEntHealth = []
        if (res.data.data){
          this.tableDataEntHealth = res.data.data.records;
          this.entHealthTablePager.total = res.data.data.total;
        }
        this.getExecutiveOmmitteeCompanyHealthTotal();
      });
    },
    getExecutiveOmmitteeCompanyHealthTotal(){
      this.$api.member
          .getExecutiveOmmitteeCompanyHealthTotal().then((res) => {
        this.tableDataEntHealthTotal = {}
        if (res.data.data){
          this.tableDataEntHealthTotal = res.data.data;
        }
      });
    },
    handleSizeChange(e) {
      this.entHealthTablePager.pageSize = e;
      this.getExecutiveOmmitteeCompanyHealth();
    },
    handleCurrentChange(e) {
      this.entHealthTablePager.currentPage = e;
      this.getExecutiveOmmitteeCompanyHealth();
    },
    searchByleftPersonSelectPerson(personName) {
      this.topSelectType = 0;
      this.executiveOmmitteeBaseInfoSelectEnterpriseName = '';
      this.executiveOmmitteeBaseInfoSelectPersonName = personName;
      this.getExecutiveOmmitteeBaseInfo();
    },
    executiveOmmitteeBaseInfoClick(){
      this.executiveOmmitteeBaseInfoShow = true;
    },
    associatedCompanyInfoClick(){
      this.associatedCompanyInfoShow = true;
      this.curData = { companyName: this.executiveOmmitteeBaseInfo.enterprise_registered_name };
    },
    warnInfoClick(){
      this.warnInfoShow = true;
      this.getWarnInfo();
    },
    getWarnInfo(){
      this.$api.member
          .getExecutiveOmmitteeCompanyHealth({
            pageCurrent: 1,
            pageSize: -1,
            personName: this.executiveOmmitteeBaseInfo.person_name,
            companyName: this.executiveOmmitteeBaseInfo.enterprise_registered_name
          }).then((res) => {
        this.tableDataWarn = [];
        this.warnPersonName = null;
        this.warnCompanyName = null;
        this.warnSocialCode = null;
        this.warnEnterpriseIndustryClassification = null;
        if (res.data.data){
          this.tableDataWarn = res.data.data.records;
          this.warnPersonName = res.data.data.records[0].personName;
          this.warnCompanyName = res.data.data.records[0].companyName;
          this.warnSocialCode = res.data.data.records[0].socialCode;
          this.warnEnterpriseIndustryClassification = res.data.data.records[0].enterpriseIndustryClassification;
        }
      });
    },
    getExecutiveOmmitteeBaseInfoPersonName(){
      this.$api.member
          .getExecutiveOmmitteeBaseInfoPersonName().then((res) => {
        if (res.data.data){
          this.executiveOmmitteeBaseInfoPersonName = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
        }else {
          this.executiveOmmitteeBaseInfoPersonName = {}
        }
      });
    },

    getExecutiveOmmitteeBaseInfoEnterpriseName(){
      this.$api.member
          .getExecutiveOmmitteeBaseInfoEnterpriseName().then((res) => {
        if (res.data.data){
          this.executiveOmmitteeBaseInfoEnterpriseName = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
        } else {
          this.executiveOmmitteeBaseInfoEnterpriseName = {}
        }
      });
    },

    getExecutiveOmmitteeBaseInfo(){
      this.$api.member
          .getExecutiveOmmitteeBaseInfo({
            personName: this.executiveOmmitteeBaseInfoSelectPersonName,
            enterpriseRegisteredName: this.executiveOmmitteeBaseInfoSelectEnterpriseName
          }).then((res) => {
        if (res.data.data){
          this.executiveOmmitteeBaseInfo = res.data.data;
          this.getExecutiveCommitteePerformance();
        } else {
          this.executiveOmmitteeBaseInfo = {};
          this.getExecutiveCommitteePerformance();
        }
      });
    },

    getExecutiveCommitteePerformance(){
      this.$api.member
          .getExecutiveCommitteePerformance({
            personName: this.executiveOmmitteeBaseInfo.person_name ? this.executiveOmmitteeBaseInfo.person_name : '-'
          }).then((res) => {
        if (res.data.data){
          this.executiveCommitteePerformance = res.data.data;
        } else {
          this.executiveCommitteePerformance = {}
        }
      });
    },


    handleLink(index) {
      this.$emit('handleLink', {
        index,
        dataType: this.dataType,
        year: this.year,
      });
    },

    openModal(e) {
      this.showEntDialog = true;
      if (e) this.search.cityName = e;
      this.getEntList();
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>

.ml12 {
  margin-left: 12px;
}
.chart-bar {
  .chart-box();
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: space-between;
  .chart-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .card-item {
      + .card-item {
        margin-top: 25px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .left {
        display: flex;
         width: 27%;
        //width: 1024px;
        //padding-left: 32px;
      }
      .right {
        display: flex;
         width: 27%;
        //width: 1024px;
        //padding-left: 32px;
      }
      .center {
        display: flex;
        width: 46%;
        //width: 1024px;
        //padding-left: 32px;
      }
    }
    .card-item-inner {
      + .card-item {
        margin-top: 25px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .card-content {
        flex: 1;
        display: flex;
        flex-direction: row;
        padding-top: 2px;
        margin: -1px 1px 1px;
        background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
        border-radius: 4px;
        border: 1px solid;
        border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
        border-top: none;
        .left {
          width: 27%;
          //width: 1024px;
          //padding-left: 32px;
        }
        .right {
          width: 27%;
          //width: 1024px;
          //padding-left: 32px;
        }
        .center {
          width: 46%;
          //width: 1024px;
          //padding-left: 32px;
        }
      }

    }
    .chart-ys {
      position: relative;
      /deep/ .el-cascader {
        // position: absolute;
        // top: 0;
        // left: 0;
        width: 130px;
        .el-input--suffix .el-input__inner {
          height: 28px;
          // padding-left: 44px;
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }

        input {
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          outline: none;
          border: none;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
      .com-table {
        .table-header {
          .table-cell {
            font-size: 12px;
          }
        }
      }
    }
    /deep/.l2-2 .card-content .com-table .table-row {
      min-height: 40px;
    }
    /deep/.l2-2 .card-content .com-table .ele-page {
      margin: 0 0
    }
    /deep/.l2-2 .card-content .com-table .com-table-wrapper {
      height: 90%;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }
    /deep/.l2-2 .card-content .com-table .com-table-wrapper .table-header {
      height: 32px;
    }
    /deep/.l2-2 .card-content .com-table .com-table-wrapper .table-header .table-cell {
      font-size: 12px;
    }
    /deep/.l2-2 .card-content .com-table .com-table-wrapper .table-body .table-cell {
      font-size: 11px;
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
          180deg,
          rgba(189, 232, 247, 1) 0%,
          rgba(191, 229, 252, 1) 20%,
          rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
      .chart-con {
        .chart-box {
          // width: 100%;
          height: 100%;
          overflow-x: scroll;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          // padding: 0 20px;
          .bar-box {
            position: relative;
            width: 28px;
            height: 100%;
            padding: 0 8.3%;
            &:after {
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              width: 68px;
              height: 76px;
              content: '';
              background: url('~img/market/bar-bottom.png') center center no-repeat;
              background-size: cover;
            }
            &.bar0:after {
              background: url('~img/market/bar-bottom1.png') center center no-repeat;
              background-size: cover;
            }
            &.bar1:after {
              background: url('~img/market/bar-bottom2.png') center center no-repeat;
              background-size: cover;
            }
            &.bar2:after {
              background: url('~img/market/bar-bottom3.png') center center no-repeat;
              background-size: cover;
            }
          }
          .city-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .num {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 14px;
              color: #ffffff;
              white-space: nowrap;
              &.city-0 {
                background: linear-gradient(0deg, #f63d01 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-1 {
                background: linear-gradient(0deg, #f48f00 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-2 {
                background: linear-gradient(0deg, #82f40e 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .name {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              color: #fdffff;
              white-space: nowrap;
            }
          }
          .bar-bg {
            width: 20px;
            height: 144px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            .bf {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              box-sizing: border-box;
              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, rgba(2, 26, 28, 0), rgba(24, 72, 117, 0.96));
              }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, rgba(24, 72, 117, 1), rgba(4, 61, 66, 0.3));
              }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: rgba(24, 72, 117, 0.6);
              }
            }
          }
          .cube {
            width: 20px;
            height: 100px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            z-index: 9;
            // animation: rotate 5s infinite linear;
            .face {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              // border: 2px solid #ccc;
              box-sizing: border-box;

              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, #1960b6, #3988ff);
              }
              // .back {
              //   transform: rotateY(180deg) translateZ(10px);
              //   background: linear-gradient(to right, #45a29e, #66bfa6);
              // }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, #072975, #1748c1);
              }
              // .left {
              //   transform: rotateY(-90deg) translateZ(10px);
              //   background: linear-gradient(to top, #ff6f61, #ffcc5c);
              // }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: #5dc9ff;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
              // .bottom {
              //   transform: rotateX(-90deg) translateZ(10px);
              //   background: linear-gradient(to left, #66bfa6, #45a29e);
              // }
            }
            &.cube-0 {
              .front {
                background: linear-gradient(to top, #d1602b, #ffaf83);
              }
              .right {
                background: linear-gradient(to bottom, #b1440e, #742111);
              }
              .top {
                background: #ff7c3a;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
            }
            &.cube-1 {
              .front {
                background: linear-gradient(to top, #ffc76e, #ffe6bf);
              }
              .right {
                background: linear-gradient(to bottom, #ac670d, #fed423);
              }
              .top {
                background: #ffcd7e;
              }
            }
            &.cube-2 {
              .front {
                background: linear-gradient(to top, #19a6b0, #00c67e);
              }
              .right {
                background: linear-gradient(to bottom, #07646a, #01b575);
              }
              .top {
                background: #60f9cc;
              }
            }
          }
        }
      }
    }
  }
  .wrapper {
    padding: 0 10px;
    * {
      box-sizing: border-box;
    }
  }
  .l1-1 {
    padding-top: 13px;
    padding-bottom: 15px;
    .info-box{
      position: relative;
      width: 248px;
      height: 228px;
      padding: 10px 0;
      padding-left: 10px;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      //align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .info-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .text-padding-left {
        padding-left: 10px;
      }
      .info-flex{
        display: flex;
        .left{
          width: calc(100%/5*2);
        }
        .right{
          width: calc(100%/5*3);
          padding-right: 6px;
        }
        .person-img {
          width: 90px;
          height: 120px;
        }
      }
      .a-class {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 14px;
        color: rgba(129, 204, 250, 0.8);
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 16px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin-top: 15px;
      }
      .sum-h2 {
        margin-right: 8px;
        font-family: YouSheTitle;
        font-weight: 400;
        font-size: 16px;
        color: #e4edf7;
      }
    }
    .sum-box {
      position: relative;
      width: 248px;
      height: 218px;
      padding: 28px 0;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      //align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .sum-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .person-img {
        width: 100px;
        height: 87px;
        background-size: 100% 100%;
      }
      .sum-img {
        width: 100px;
        height: 87px;
        background: url('~img/market/market-l-sum.png') no-repeat;
        background-size: 100% 100%;
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 18px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin: 10px;
      }
      .sum-h2 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: rgba(239, 240, 241, 0.6);
        line-height: 1;
        b {
          margin-right: 8px;
          font-family: YouSheTitle;
          font-weight: 400;
          font-size: 26px;
          color: #e4edf7;
        }
      }
    }
    .sum-list {
      flex: 1;
      height: 100%;
      max-height: 218px;
      overflow-y: scroll;
      .list-item {
        + .list-item {
          margin-top: 18px;
        }
        .item-top {
          &.item1 {
            .top-l span {
              color: #fb3c00;
            }
            .top-r span {
              background: linear-gradient(0deg, #f63d01 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item2 {
            .top-l span {
              color: #fa9300;
            }
            .top-r span {
              background: linear-gradient(0deg, #f48f00 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item3 {
            .top-l span {
              color: #7ffc00;
            }
            .top-r span {
              background: linear-gradient(0deg, #82f40e 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item4 {
            .top-l span {
              color: #49acff;
            }
            .top-r span {
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          .top-l {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            span {
              font-family: Myriad Pro;
              font-weight: 400;
              font-size: 16px;
              color: #49acff;
              margin-right: 19px;
            }
          }
          .top-r {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #d8e2ff;
            font-style: italic;
            span {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 18px;
              color: #ffffff;
              font-style: italic;
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 3px;
              margin-right: 4px;
            }
          }
        }
        .item-line {
          width: 100;
          height: 16px;
          background: rgba(16, 28, 52, 0.5);
          padding: 5px 4px;
          margin-top: 2px;
          .line {
            position: relative;
            width: 100%;
            height: 4px;
            background: #0a284a;
            border-radius: 2px;
            div {
              position: absolute;
              left: 0;
              top: -1px;
              width: 80%;
              height: 6px;
              background: linear-gradient(270deg, #51b0ff 0%, rgba(0, 120, 255, 0) 100%);
              border-radius: 2px;
              i {
                position: absolute;
                right: 0;
                top: -2px;
                width: 10px;
                height: 10px;
                display: inline-block;
                background: #e3f2ff;
                box-shadow: 0 0 7px rgba(227, 242, 255, 1);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
  .l2-1 {
    //height: calc(100% / 3 * 2);
    .list-box {
      width: 100%;
      height: 253px;
      padding: 17px 0 8px;
      overflow-y: scroll;
      .list-item {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #2b97ff;
        padding: 0 39px 0 36px;
        + .list-item {
          margin-top: 5px;
        }
        .item-l {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
          line-height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          b {
            width: 26px;
            text-align: center;
            font-family: Geometr706 BlkCn BT;
            font-weight: 900;
            font-size: 22px;
            color: #00c9ff;
            font-style: italic;
            background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-right: 22px;
          }
        }
        .item-c {
          height: 20px;
          padding: 0 13px;
          background: rgba(252, 245, 194, 0.2);
          border-radius: 2px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #fcf5c2;
          line-height: 20px;
        }
        .item-r {
          width: 80px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #dcdcdc;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          i {
            width: 12px;
            height: 12px;
            line-height: 12px;
            font-family: Geometr706 BlkCn BT;
            font-size: 20px;
            color: #dcdcdc;
            font-style: normal;
            margin-right: 11px;
            white-space: nowrap;
          }
          &.trend1 {
            background: linear-gradient(-7deg, #ffca00 0%, #ff5a00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-up.png') center center no-repeat;
              background-size: cover;
            }
          }
          &.trend2 {
            background: linear-gradient(0deg, #19490a 0.9033203125%, #7cfa00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-down.png') center center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .chart-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 56px 0 0 17px;
    // border: NaNpx solid;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
    border-radius: 4px;
  }
  /deep/ .po {
    margin: 0;
    height: 0;
    .list {
      position: absolute;
      top: 12px;
      left: 19px;
      right: unset;
    }
  }
  .chart-statistics {
    position: relative;
    background: rgba(1, 20, 48, 0.08);
    border: 2px solid rgba(#095194, 0.2);
    padding: 17px 91px 13px 29px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      height: 4px;
      background: #7af0fc;
      &.i2 {
        left: 14px;
        opacity: 0.6;
        &.r {
          right: 14px;
        }
      }
      &.i3 {
        left: 27px;
        opacity: 0.2;
        &.r {
          right: 27px;
        }
      }
      &.r {
        left: unset;
        right: 0;
      }
    }
    .item-title {
      position: relative;
      height: 21px;
      perspective: 50px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 211px;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
    }
    .span-label,
    .span-num {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 19px;
    }
    .span-num {
      color: #ff6a6a;
      margin-right: 0;
    }
    .stat-left .span-num {
      padding-left: 44px;
      font-size: 24px;
      font-weight: 900;
      color: #6acbff;
      line-height: 38px;
    }
    .span-unit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      line-height: 29px;
      opacity: 0.6;
      margin-left: 10px;
    }
    .div-i {
      width: 16px;
      height: 16px;
      margin-right: 9px;
      display: inline-block;
      background: url('~img/commonImg/chart-stat.png') no-repeat;
      background-size: 100% 100%;
    }
    .stat-center,
    .stat-right {
      display: inline-flex;
      align-items: center;
      &.des {
        .div-i {
          transform: rotate(180deg);
        }
        .span-num {
          color: rgba(88, 236, 172, 1);
        }
      }
    }
  }
  .sub-title {
    padding: 20px 9px 0px 10px;
    font-size: 18px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 5px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .chart-con {
    flex: 1;
    height: 198px;
    /deep/ .echarts > div {
      max-height: 100%;
      canvas {
        height: 100% !important;
      }
    }
  }
  .left-bottom {
    display: flex;
    > div {
      width: calc(50% - 13px);
      &:first-of-type {
        margin-right: 26px;
      }
      /deep/ .title {
        white-space: nowrap;
        width: 100%;
        #btn-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      /deep/ .flex-between {
        height: 52px;
      }
    }
  }
  /deep/ .ele-dialog {
    z-index: 9999;
    .item-label {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      line-height: 1;
      text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
      font-style: italic;
      b {
        font-size: 26px;
      }
      .comment-font {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #CE5E03FF;
        line-height: 1;
        text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
        font-style: italic;
      }
    }
    &.info-modal {
      z-index: 999;
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }

    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
  }
}


//原型UI
.flex-col{
  display: flex;
  flex-direction: column;
}
.flex-row{
  display: flex;
  flex-direction: row;
}
.group_10 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 100%;
  border: 1px solid rgba(148, 255, 255, 0.15);
  //margin-left: 34px;
  width: 100%;
  position: relative;
  justify-content: flex-center;
}
.box_12 {
  display: flex;
  flex-direction: row;
  width: 994px;
  height: 34px;
  margin: 16px 0 0 14px;
}
.block_6 {
  position: relative;
  width: 236px;
  height: 25px;
  margin-top: 6px;
}
.image-wrapper_1 {
  height: 18px;
  background: url('~img/member/center-sub-title-bg.png')
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 7px;
  width: 236px;
}
.thumbnail_4 {
  width: 16px;
  height: 20px;
  margin: -7px 0 0 17px;
}
.text_94 {
  position: absolute;
  left: 45px;
  top: 0;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 41px;
}
.block_7 {
  //background-image: linear-gradient(
  //    180deg,
  //    rgba(57, 108, 206, 1) 0,
  //    rgba(57, 108, 206, 0.501961) 0,
  //    rgba(61, 164, 255, 1) 6.005859%,
  //    rgba(57, 108, 206, 1) 100%,
  //    rgba(57, 108, 206, 0.109804) 100%
  //);
  border-radius: 3px;
  //width: 100px;
  height: 24px;
  margin-left: 95px;
}
.text_95 {
  width: 35px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 37px;
  margin: 6px 0 0 10px;
}
.thumbnail_5 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 37px;
}
.block_8 {
  width: 177px;
  height: 21px;
  margin: 4px 0 0 10px;
}
.group_11 {
  width: 122px;
  height: 16px;
}
.thumbnail_6 {
  width: 16px;
  height: 16px;
}
.text_96 {
  width: 95px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(160, 220, 236, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 37px;
  margin-top: 2px;
}
.group_12 {
  background-image: linear-gradient(
      90deg,
      rgba(38, 76, 152, 1) 0,
      rgba(38, 76, 152, 1) 0.585938%,
      rgba(38, 76, 152, 0.729412) 12.011719%,
      rgba(92, 182, 255, 1) 48.217773%,
      rgba(92, 182, 255, 1) 48.632812%,
      rgba(92, 182, 255, 0.709804) 89.18457%,
      rgba(38, 76, 152, 1) 99.316406%,
      rgba(38, 76, 152, 1) 99.414062%
  );
  width: 177px;
  height: 2px;
  margin-top: 3px;
}
.block_9 {
  height: 28px;
  margin: 6px 0 0 75px;
}
.block_10 {
  width: 236px;
  height: 24px;
  margin-left: 45px;
}
.block_10_image-wrapper_1 {
  height: 18px;
  background: url('~img/member/center-sub-title-bg.png')
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 7px;
  width: 236px;
}
.label_4 {
  width: 22px;
  height: 24px;
}
.text_97 {
  position: absolute;
  padding-left: 45px;
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 41px;
  //margin-top: 0px;
}
.image_9 {
  width: 216px;
  height: 18px;
  margin-top: -14px;
}
.box_13 {
  display: flex;
  flex-direction: row;
  //width: 100%;
  height: 100%;
  margin: 6px 14px 16px 14px;
}
.group_13 {
  position: relative;
  width: calc(100% / 8 * 2);
  height: 100%;
}
.block_11 {
  display: flex;
  flex-direction: column;
  height: 510px;
  background: url('~img/member/center-bg-2.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 218px;
}
.block_11_1 {
  display: flex;
  flex-direction: column;
  height: 220px;
  background: url('~img/member/center-bg-2.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 218px;
}
.group_14 {
  display: flex;
  flex-direction: row;
  width: 193px;
  height: 102px;
  margin: 15px 0 0 14px;
}
.box_14 {
  //display: flex;
  //flex-direction: row;
  background-color: rgba(248, 250, 253, 1);
  width: 75px;
  height: 100px;
}
.text-wrapper_18 {

  width: 34px;
  height: 44px;
  margin: 58px 0 0 12px;
}
.text_98 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
}
.text_99 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-top: 16px;
}
.text-wrapper_19 {
  width: 66px;
  height: 102px;
  margin-left: 6px;
}
.text_100 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  //line-height: 18px;
  margin-left: 32px;
  cursor: pointer;
}
.text_101 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-top: 44px;
}
.text_102 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-top: 17px;
}
.text-wrapper_20 {
  display: flex;
  flex-direction: row;
  width: 189px;
  height: 15px;
  margin: 18px 0 0 14px;
}
.text_103 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-top: 1px;
}
.text_104 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_105 {
  width: 33px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-left: 20px;
}
.text_106 {
  width: 41px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-left: 6px;
}
.text-wrapper_21 {
  display: flex;
  flex-direction: row;
  width: 189px;
  height: 15px;
  margin: 19px 0 36px 14px;
}
.text_107 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
}
.text_107_1 {
  width: 62px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
}
.text_107_2 {
  width: 72px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
}
.text_108 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_108_1 {
  /*width: 5px;*/
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  /*white-space: nowrap;*/
  //line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_109 {
  width: 69px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 1px 0 0 36px;
}
.text_110 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  //white-space: nowrap;
  //line-height: 27px;
  margin: 1px 0 0 6px;
}
.image-wrapper_2 {
  height: 18px;
  background: url('~img/member/center-sub-title-bg.png')
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 55px;
  width: 236px;
}
.image-wrapper_2_1 {
  height: 18px;
  background: url('~img/member/center-sub-title-bg.png')
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 31px;
  width: 236px;
}
.image_10 {
  width: 20px;
  height: 22px;
  margin: -10px 0 0 18px;
}
.block_12 {
  width: 218px;
  height: 210px;
  background: url('~img/member/center-bg-2.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin: 9px 0 0 5px;
}
.block_12_1 {
  width: 218px;
  height: 230px;
  background: url('~img/member/center-bg-2.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin: 9px 0 0 5px;
}
.text_111 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  //line-height: 18px;
  margin: 10px 0 0 173px;
  cursor: pointer;
}
.text_112 {
  width: 59px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 9px 0 0 14px;
}
.text_113 {
  width: 179px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(246, 248, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 4px 0 0 13px;
}
.text_114 {
  width: 58px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 13px 0 0 14px;
}
.text_115 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 4px 0 0 14px;
}
.text_116 {
  width: 57px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 14px 0 0 15px;
}
.text_117 {
  width: 178px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin: 6px 0 0 13px;
}
.text-group_1 {
  width: 88px;
  height: 32px;
  margin: 13px 0 24px 13px;
}
.text_118 {
  width: 87px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-left: 1px;
}
.text_119 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(96, 249, 204, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-top: 4px;
}
.text_119-1 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgb(236, 41, 76);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 27px;
  margin-top: 4px;
}
.text_119_1_1 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  //line-height: 18px;
  margin: 15px 0 0 90px;
  cursor: pointer;
}

.text_120_1 {
  position: absolute;
  left: 45px;
  top: 45px;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 41px;
}
.text_120 {
  position: absolute;
  left: 45px;
  top: 244px;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 41px;
}
.group_15 {
  position: relative;
  width: calc(100% / 8 * 4);
  height: 100%;
  margin: 12px 0 0 0px;
}
.box_15 {
  height: 48px;
  background: url('~img/member/center-tab-1.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 189px;
  width: 325px;
  position: relative;
}
.text_121 {
  width: 187px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  //white-space: nowrap;
  //line-height: 14px;
  margin: 4px 0 0 80px;
}
.image-wrapper_3 {
  height: 40px;
  background: url('~img/member/center-tab-2.png') -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -172px;
  top: 4px;
}
.image_11 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.box_16 {
  position: relative;
  width: 102px;
  height: 105px;
  //background: url('~img/member/center-middle-icon.png') -2px -4px
  //background: url('~img/member/center-middle-icon2.png') -2px -4px
  //no-repeat;
  background-size: 112px 112px;
  margin: 4px 0 0 185px;
}

.box_16_1 {
  position: relative;
  width: 102px;
  height: 105px;
  //background: url('~img/member/center-middle-icon.png') -2px -4px
  background: url('~img/member/center-middle-icon2.png') -2px -4px
  no-repeat;
  background-size: 112px 112px;
  margin: 4px 0 0 185px;
}
.text-wrapper_22 {
  position: absolute;
  left: 110px;
  top: 74px;
  width: 260px;
  height: 48px;
  background: url('~img/member/center-tab-1.png')
  100% no-repeat;
  background-size: 100% 100%;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: left;      /* 垂直居中 */
}
.text_122 {
  width: 200px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: right;
  //white-space: nowrap;
  //line-height: 14px;
  //margin: 9px 0 0 59px;
}
.text_123 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 12px;
  margin: 4px 0 12px 105px;
}
.text-wrapper_23 {
  height: 48px;
  background: url('~img/member/center-tab-1.png')
  100% no-repeat;
  background-size: 100% 100%;
  width: 260px;
  position: absolute;
  left: 110px;
  top: 10px;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: left;      /* 垂直居中 */
}
.text_124 {
  width: 200px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: right;
  //white-space: nowrap;
  //line-height: 14px;
  //margin: 18px 0 0 102px;
}
.image-wrapper_4 {
  height: 40px;
  background: url('~img/member/center-tab-2.png') -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -201px;
  top: 14px;
}
.image_12 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.image-wrapper_5 {
  height: 40px;
  background: url('~img/member/center-tab-2.png') -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -201px;
  top: 77px;
}
.image_13 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.image-wrapper_6 {
  width: 496px;
  height: 18px;
  margin-top: 164px;
}

.image-wrapper_6_1 {
  width: 496px;
  height: 18px;
  margin-top: 114px;
}
.image_14 {
  width: 236px;
  height: 18px;
}
.image_15 {
  width: 236px;
  height: 18px;
}
.box_17 {
  display: flex;
  flex-direction: row;
  width: 478px;
  height: 128px;
  margin: 9px 0 0 5px;
}
.box_18 {
  width: 218px;
  height: 148px;
  background: url('~img/member/center-bg-3.png')
  100% no-repeat;
  background-size: 100% 100%;
  //align-items: center;
}

.box_18_11 {
  width: 218px;
  height: 198px;
  background: url('~img/member/center-bg-3.png')
  100% no-repeat;
  background-size: 100% 100%;
  //align-items: center;
}
.box_18_1 {
  width: 218px;
  height: 190px;
  overflow: auto;
  align-items: center;
}
.box_19 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  //height: 30px;
  margin-top: 9px;
  width: 200px;
}
.box_21 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  //height: 30px;
  margin-top: 9px;
  width: 200px;
}
.box_20 {
  width: 34px;
  //height: 4px;
  margin-top: 1px;
}
.section_9 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_10 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_11 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_24 {
  width: 200px;
  //height: 13px;
  //margin: 3px 0 9px 54px;
}
.text_125 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 200px;
  //height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  padding-bottom: 2px;
  //white-space: nowrap;
  //line-height: 28px;
}
//.box_21 {
//  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
//  background-image: linear-gradient(
//      90deg,
//      rgba(52, 114, 223, 0.120784) 0,
//      rgba(52, 114, 223, 0.120784) 0.585938%,
//      rgba(48, 158, 255, 0.4) 46.655273%,
//      rgba(48, 158, 255, 0.4) 49.023438%,
//      rgba(48, 158, 255, 0.123922) 99.023438%,
//      rgba(52, 114, 223, 0.4) 100%
//  );
//  border-radius: 4px;
//  height: 30px;
//  margin-top: 9px;
//  width: 217px;
//}
.section_12 {
  width: 34px;
  height: 4px;
}
.group_16 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.group_17 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.group_18 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_25 {
  width: 96px;
  height: 13px;
  margin: 3px 0 10px 60px;
}
.text_126 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 96px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
}
.box_22 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 30px;
  margin-top: 9px;
  width: 217px;
}
.group_19 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.section_13 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_14 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_15 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_26 {
  width: 96px;
  height: 13px;
  margin: 3px 0 9px 60px;
}
.text_127 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 96px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
}
.box_23 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 30px;
  width: 217px;
  margin: 9px 0 38px 0;
}
.group_20 {
  width: 34px;
  height: 4px;
}
.section_16 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_17 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_18 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_27 {
  width: 143px;
  height: 12px;
  margin: 5px 0 9px 37px;
}
.text_128 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 143px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
}
.box_24 {
  width: 218px;
  height: 148px;
  background: url('~img/member/center-bg-3.png')
  100% no-repeat;
  background-size: 100% 100%;
}
.box_24_1 {
  width: 218px;
  height: 198px;
  background: url('~img/member/center-bg-3.png')
  100% no-repeat;
  background-size: 100% 100%;
}
.box_25 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 46px;
  margin-top: 13px;
  width: 217px;
}
.section_19 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.box_26 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.box_27 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.box_28 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_28 {
  width: 193px;
  height: 27px;
  margin: 5px 0 9px 14px;
}
.paragraph_2 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 193px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
}
.box_29 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 29px;
  margin-top: 10px;
  width: 217px;
}
.box_30 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.block_13 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.block_14 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.block_15 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_29 {
  width: 180px;
  height: 13px;
  margin: 3px 0 8px 18px;
}
.text_129 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 180px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
}
.box_31 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 29px;
  margin-top: 10px;
  width: 217px;
}
.section_20 {
  width: 34px;
  height: 4px;
}
.group_21 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.group_22 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.group_23 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_30 {
  width: 163px;
  height: 13px;
  margin: 4px 0 8px 26px;
}
.text_130 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 163px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
}
.box_32 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 29px;
  width: 217px;
  margin: 9px 0 23px 0;
}
.group_24 {
  width: 34px;
  height: 4px;
}
.box_33 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.box_34 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.box_35 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_31 {
  width: 150px;
  height: 12px;
  margin: 5px 0 8px 34px;
}
.text_131 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 150px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
}
.box_36 {
  position: absolute;
  left: 18px;
  top: 310px;
  width: 366px;
  height: 25px;
}
.box_36_1 {
  position: absolute;
  left: 18px;
  top: 260px;
  width: 366px;
  height: 25px;
}
.label_5 {
  width: 22px;
  height: 24px;
  margin-top: 1px;
}
.text_132 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 41px;
  margin: 4px 0 0 10px;
}
.label_6 {
  width: 27px;
  height: 24px;
  margin-left: 155px;
}
.text_133 {
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 41px;
  margin: 4px 0 0 9px;
}
.group_25_1 {
  position: absolute;
  width: calc(100% / 8 * 2);
  height: 180px;
  background-size: 100% 100%;
  margin: 222px 0 0 0px;
  margin-left: 800px;
  //align-items: center;      /* 垂直居中 */
  //overflow: auto;
}
.group_25 {
  width: calc(100% / 8 * 2);
  height: 250px;
  background: url('~img/member/center-bg-4.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin: 3px 0 0 0px;
  //align-items: center;      /* 垂直居中 */
  //overflow: auto;
}
.group_25_2 {
  width: calc(100% / 8 * 2);
  height: 505px;
  background: url('~img/member/center-bg-4.png')
  100% no-repeat;
  background-size: 100% 100%;
  margin: 3px 0 0 0px;
  //align-items: center;      /* 垂直居中 */
  //overflow: auto;
}
.group_25_div {
  width: 100%;
  height: 495px;
  //background: url('~img/member/center-bg-4.png')
  /*100% no-repeat;*/
  //background-size: 100% 100%;
  //margin: 3px 0 0 0px;
  align-items: center;      /* 垂直居中 */
  overflow: auto;
}
.box_37 {
  //position: absolute;
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  //min-height: 28px;
  width: 240px;
  position: relative;
  //margin: 7px 0 0 4px;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
  margin-top: 10px;
}
.text_134 {
  //position: absolute;
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 240px;
  //height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  //white-space: nowrap;
  //line-height: 28px;
  //margin: 8px 0 0 55px;
}
.image_16 {
  //position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_17 {
  //position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_38 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.text_135 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 106px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
  margin: 7px 0 0 47px;
}
.image_18 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_19 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_39 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_3 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 134px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
  margin: 7px 0 0 32px;
}
.image_20 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_21 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_40 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_4 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 122px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
  margin: 8px 0 0 38px;
}
.image_22 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_23 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_41 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_5 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 101px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
  margin: 7px 0 0 49px;
}
.image_24 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_25 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_42 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_6 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 125px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
  margin: 7px 0 0 37px;
}
.image_26 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_27 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_43 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_7 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 132px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
  margin: 8px 0 0 33px;
}
.image_28 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_29 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_44 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.text_136 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 118px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
  margin: 8px 0 0 41px;
}
.image_30 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_31 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_45 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_8 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 120px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  //line-height: 14px;
  margin: 7px 0 0 37px;
}
.image_32 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_33 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_46 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 13px 0 8px 4px;
}
.text_137 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 120px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 28px;
  margin: 8px 0 0 40px;
}
.image_34 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_35 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_47_2 {
  position: absolute;
  left: 470px;
  top: 150px;
  width: 110px;
  height: 110px;
  background: url('~img/member/center-middle-icon2.png') -2px -4px
  no-repeat;
  background-size: 100% 100%;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.box_47_1 {
  position: absolute;
  left: 455px;
  top: 310px;
  width: 330px;
  height: 48px;
  background: url('~img/member/center-tab-1.png')
  100% no-repeat;
  background-size: 100% 100%;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.box_47 {
  position: absolute;
  left: 485px;
  top: 255px;
  width: 330px;
  height: 48px;
  background: url('~img/member/center-tab-1.png')
  100% no-repeat;
  background-size: 100% 100%;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.text_138 {
  width: 185px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: right;
  //white-space: nowrap;
  //line-height: 14px;
  //margin: 10px 0 0 108px;
}
.text_139 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 12px;
  margin: 4px 0 11px 131px;
}
.text-wrapper_32 {
  //position: absolute;
  //left: -278px;
  //top: 0;
  //width: 230px;
  //height: 48px;
  //background: url('~img/member/center-tab-3.png')
  //100% no-repeat;
  //background-size: 100% 100%;
  //display: flex;
  //justify-content: center;  /* 水平居中 */
  //align-items: center;      /* 垂直居中 */
  position: absolute;
  left: 222px;
  top: 250px;
  width: 340px;
  height: 47px;
  background: url('~img/member/center-tab-3.png')
  0px 0px no-repeat;
  background-size: 265px 48px;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.text-wrapper_32_1 {
  //position: absolute;
  //left: -278px;
  //top: 0;
  //width: 230px;
  //height: 48px;
  //background: url('~img/member/center-tab-3.png')
  //100% no-repeat;
  //background-size: 100% 100%;
  //display: flex;
  //justify-content: center;  /* 水平居中 */
  //align-items: center;      /* 垂直居中 */
  position: absolute;
  left: 252px;
  top: 310px;
  width: 340px;
  height: 47px;
  background: url('~img/member/center-tab-3.png')
  0px 0px no-repeat;
  background-size: 265px 48px;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.text_140 {
  //width: 185px;
  ////height: 11px;
  //overflow-wrap: break-word;
  //color: rgba(247, 249, 255, 1);
  //font-size: 14px;
  //font-family: YouSheBiaoTiHei;
  //font-weight: normal;
  //text-align: left;
  ////white-space: nowrap;
  ////line-height: 14px;
  ////margin: 10px 0 0 77px;
  width: 200px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  //white-space: nowrap;
  //line-height: 14px;
  //margin: 10px 0 0 16px;
}
.text_141 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 12px;
  margin: 4px 0 11px 123px;
}
.text-wrapper_33 {
  position: absolute;
  left: 293px;
  top: 68px;
  width: 230px;
  height: 47px;
  background: url('~img/member/center-tab-4.png')
  0px 0px no-repeat;
  background-size: 265px 48px;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.text_142 {
  width: 185px;
  //height: 11px;
  overflow-wrap: break-word;
  //word-break: break-all;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;

  //white-space: nowrap;
  //line-height: 14px;
  //margin: 10px 0 0 16px;
}
.text_143 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_34 {
  position: absolute;
  left: 259px;
  top: 130px;
  width: 230px;
  height: 47px;
  background: url('~img/member/center-tab-4.png')
  0px 0px no-repeat;
  background-size: 265px 48px;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.text_144 {
  width: 185px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  //white-space: nowrap;
  //line-height: 14px;
  //margin: 10px 0 0 16px;
}
.text_145 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_35 {
  position: absolute;
  left: 259px;
  top: 193px;
  width: 230px;
  height: 47px;
  background: url('~img/member/center-tab-4.png')
  0px 0px no-repeat;
  background-size: 265px 48px;
  //justify-content: flex-center;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
}
.text_146 {
  width: 185px;
  //height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  //white-space: nowrap;
  //line-height: 14px;
  //margin: 10px 0 0 16px;
}
.text_147 {
  width: 94px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  //line-height: 12px;
  margin: 3px 0 10px 47px;
}

.justify-between{
  display: flex;
  justify-content: space-between;
}


.box_63 {
  width: 978px;
  height: 46px;
  margin: 15px 0 0 21px;
}
.label_7 {
  width: 43px;
  height: 46px;
}
.image_60 {
  width: 476px;
  height: 18px;
  margin: 6px 0 0 17px;
}
.text-wrapper_47 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 24px;
  margin: 5px 0 0 -460px;
}
.text_210 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text_211 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(212, 189, 89, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.paragraph_12 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text_212 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.text_213 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text_214 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(255, 97, 99, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.text_215 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.text_216 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}

.filter-box{
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  //margin-bottom: 20px;
  .flex-center();
  justify-content: flex-end;
}

.ml12 {
  margin-left: 12px;
}

.long-select {
  width: 150px;
  /deep/.el-select {
    width: 100%;
  }
}
.executive-ommittee-base-info {
  /deep/.el-dialog__body {
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
    .item-content {
      // padding: 0;
    }
  }
}

&.executive-ommittee-base-info .el-row {
  padding-top: 10px;
}

.warn-info {
  /deep/.el-dialog__body {
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
    .item-content {
      // padding: 0;
    }
  }
}

&.warn-info .el-row {
  padding-top: 10px;
}


</style>
